import React, { Component } from "react";
import { ModuleAccordionGroup } from "@loanbossinc/component-library";
import { AccordionSection } from "component-lib/AccordionSection";

import { PROPERTY_SECTION_KEYS } from "../property.constants";

import { rows } from "./section-property-history-rows";

export class PropertyHistory extends Component {
  render() {
    const { data, propertyId, history, enableEditButton, ...other } = this.props;
    if (!data) {
      return null;
    }

    return (
      <ModuleAccordionGroup
        {...other}
        groups={[
          {
            title: "Property History",
            key: PROPERTY_SECTION_KEYS.PROPERTY_HISTORY,
            isExpandable: true,
            isTitleGroup: true,
            buttonLabel: "Edit Details",
            showEditButton: enableEditButton,
            onClick: () => history.push(`/properties/${propertyId}/edit/${PROPERTY_SECTION_KEYS.PROPERTY_HISTORY}`),
            sections: [
              <AccordionSection eventHandlers={this.props.eventHandlers} rows={rows} data={data} />
            ]
          }
        ]}
      />
    );
  }
}
